import { Form, Formik } from "formik";
import moment from 'moment';
import "moment-timezone";
import React, { Component } from "react";
import { Button, ControlLabel, Modal } from 'react-bootstrap';
import Alert from 'react-s-alert';
import * as Yup from "yup";
import FormikDatetime from '../Shared/FormikDateTime';
import FormikFormControl from '../Shared/Forms/FormikFormControl';
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import DealsService from '../utils/DealsService';

class PutOnHoldModal extends Component {
  render() {
    const { showModal, onCloseModal } = this.props
    const validationSchema = Yup.object().shape({
      on_hold_reason: Yup.string().required('need to provide a reason').min(15, "minimum 15 characters").max(200, "maximum 200 characters"),
      on_hold_until: Yup.date().required('must have a date to come off hold')
    });

    const validDate = function (current) {
      return current.isAfter(moment().endOf('day')) && current.isBefore(moment().add(1, 'year').startOf('day'))
    };

    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Put Deal On Hold</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{ on_hold_reason: '', on_hold_until: moment().add(1, 'days').hours(8).startOf('hour').toDate() }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              const { onConfirmModal } = this.props
              const { deal } = this.props
              DealsService.takeAction('put_on_hold', deal.id, values).then(data => {
                Alert.success('On Hold')
                onConfirmModal(data)
              });
            }}
            render={({
              errors,
              touched,
              isValid,
              isSubmitting,
              values,
              setFieldTouched,
              setFieldValue
            }) => (
                <Form>

                  <FormikTextAreaControl fieldLabel='Why is this going on hold?' fieldName='on_hold_reason' errors={errors} touched={touched} textareaHeight={100} />

                  <FormikFormControl fieldName='on_hold_until' errors={errors} touched={touched}>
                    <ControlLabel>Comes off hold when?</ControlLabel>
                    <FormikDatetime
                      isValidDate={validDate}
                      field="on_hold_until"
                      input={{
                        value: moment(values.on_hold_until).format("DD MMM YYYY h:mma"),
                        onChange: setFieldValue,
                        onBlur: setFieldTouched
                      }}
                      closeOnSelect={true}
                      dateFormat="DD MMM YYYY"
                      timeFormat="h:mma"
                    />
                  </FormikFormControl>



                  <div style={{ marginTop: 20 }}>
                    <Button onClick={onCloseModal} bsSize='small'>Whoops, cancel this</Button>
                    <Button className='pull-right' disabled={!isValid || isSubmitting} type="submit" bsStyle='success' bsSize='small'>Put Deal On Hold</Button>
                  </div>
                </Form>
              )} />
        </Modal.Body>
      </Modal>)
  }
}

export default PutOnHoldModal